
import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

interface UseBreederAnnouncementsProps {
  breederId: string;
}

// Helper function to validate UUID format
const isValidUUID = (str: string): boolean => {
  const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
  return uuidRegex.test(str);
};

export const useBreederAnnouncements = ({ breederId }: UseBreederAnnouncementsProps) => {
  return useQuery({
    queryKey: ['breeder-announcements', breederId],
    queryFn: async () => {
      // Check if breederId is a valid UUID
      if (!breederId || !isValidUUID(breederId)) {
        console.log('Invalid breeder ID provided:', breederId);
        return [];
      }

      const { data, error } = await supabase
        .from('announcements')
        .select('*')
        .eq('breeder_id', breederId)
        .order('created_at', { ascending: false });

      if (error) {
        console.error('Error fetching breeder announcements:', error);
        throw error;
      }

      return data || [];
    },
  });
};
